<template>
  <div v-show="soldout" class="complete-error">
    <div class="complete-error__heading">
      <i class="fas fa-exclamation-circle"></i>売り切れ
    </div>
    <div class="complete-error__body">
      <p>
        売り切れになった商品が選択されています。<br>
        別の商品に変更することで購入画面へ進むことが出来ます。
      </p>
    </div>
    <div class="complete-error__list" v-for="(item, index) in items" :key="item.id">
      <div class="complete-error__item" v-if="item.soldout">
        <router-link
          class="complete-error__link"
          :to="{
            path: [$route.path.match(/gogatsu/) ?  config.path.root_gogatsu : config.path.root] + '/step/' + item.page.slug + '/' + item.page.order,
            query: $route.query
          }"><i class="fas fa-caret-right"></i>{{ item.name }}</router-link>
      </div>
    </div>
  </div>
</template>



<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      items(state) {
        let items = state.cart.items

        for (var key in items) {
          if (items[key].soldout) {
            this.soldout = true
            break
          }
        }

        if (this.soldout) {
          this.$emit('error', true)
        } else {
          this.$emit('error', false)
        }

        return items
      },
    }),
  },
  data() {
    return {
      soldout: false,
    }
  },
  methods: {
  }
}
</script>



<style lang="scss">
.complete-error {
  border-radius: 4px;
  border: 1px solid $oc-red-2;
  background-color: $oc-red-0;
  padding: 20px 28px;
  &__heading {
    font-size: 16px;
    font-weight: bold;
    color: $accent-color;
    .fas {
      font-size: 18px;
      margin-right: 8px;
    }
    margin-bottom: 16px;
  }
  &__body {
    line-height: 1.6;
    margin-bottom: 16px;
  }
  &__list {
  }
  &__item {
    position: relative;
    font-size: 13px;
    line-height: 1.5;
    padding-left: 10px;
    .fas {
      font-size: 14px;
      margin-right: 12px;
    }
  }
  &__link {
    @include hover() {
      text-decoration: underline;
    }
    @include active() {
      text-decoration: underline;
    }
  }
}

.app-gogatsu {
    .complete-error {
        &__item {
            a {
                color: $accent-color;
            }
        }
    }
}
</style>
